import { Component, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { catchError, finalize, map } from 'rxjs/operators';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from './services/auth.service';
import { Router } from '@angular/router';
import { Title } from "@angular/platform-browser";
import { environment } from '../environments/environment';

declare var $: any;

@Injectable()
export class HTTPStatus {
  private requestInFlight$: BehaviorSubject<boolean>;
  constructor() {
    this.requestInFlight$ = new BehaviorSubject(false);
  }

  setHttpStatus(inFlight: boolean) {
    this.requestInFlight$.next(inFlight);
  }

  getHttpStatus(): Observable<boolean> {
    return this.requestInFlight$.asObservable();
  }
}
@Injectable()
export class HTTPListener implements HttpInterceptor {
  userData: any = {};
  constructor(
    private status: HTTPStatus,
    private cookieService: CookieService,
    private userService: AuthService,
    private route: Router) {
  }
  logOut(req) {
    this.cookieService.delete('OBSIDIAM-ADIMIN-AUTH');
    // this.cookieService.deleteAll();
    this.userService.isLoggedIn = false;
    localStorage.clear();
    this.route.navigate(['/login']);
  }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let params;
    params = req.params;
    return next.handle(req.clone({
      params
    })).pipe(
      map(event => {
        // console.log(event, this.route.url);
        // tslint:disable-next-line:no-bitwise
        // $('.loading-screen-wrapper').modal('hide');
        return event;
      }),
      catchError(error => {
        this.status.setHttpStatus(false);
        if (error.status === 401) {
          this.logOut(req);
        } else {
          console.log(error);
          return throwError(error);
        }
      }),
      finalize(() => {
        this.status.setHttpStatus(false);
      })
    );
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  constructor(
    private translate: TranslateService,
    private titleService: Title
  ) {
    const locale = localStorage.getItem('OBSIDIAM-ADMIN-LOCALE') || 'en';
    this.translate.setDefaultLang(locale);
    let title = ''
    if (environment.staging) {
      title = 'Stage-Admin-Approval'
    } else if (environment.production) {
      title = 'Admin-Approval'
    } else {
      title = 'Dev-Admin-Approval'
    }
    this.titleService.setTitle(title);

  }
}
